/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {invalidateNbaCache} from '../api'

export const useMutationInvalidateNbaCache = createReactQueryMutationHook('invalidateNbaCache', invalidateNbaCache)
